import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { PdfReportItem } from './pdf-report.model';

export interface PdfReportState extends EntityState<PdfReportItem> {
    ui: {
        updatedAt: Date | null;
        active: boolean;
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'pdfReport' })
export class PdfReportStore extends EntityStore<PdfReportState> {
    constructor() {
        super({
            ui: {
                updatedAt: null,
                active: false
            }
        });
    }
}
